import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { EventTypes } from '@cashier-integration/model';

import {
  initiateConfirmation,
  initiateNewTransaction,
  resetPaymentMethod,
  selectConfirmationFormActivated,
  selectPaymentMethod,
} from '@cashier/cashier-data-access';
import { WindowNames } from '@cashier/cashier-model';
import { eventBus, ProviderWindowService } from '@cashier/cashier-shared';

interface UseConfirmationFormProps {
  isVisible: boolean;
  methodName: string;
  onSubmit: () => void;
  onCancel: () => void;
}

export const useConfirmationForm = (): UseConfirmationFormProps => {
  const isConfirmationFormActivated = useSelector(
    selectConfirmationFormActivated,
  );
  const paymentMethod = useSelector(selectPaymentMethod);

  const dispatch = useDispatch();

  const { name: methodName } = paymentMethod;

  const handleSubmit = useCallback((): void => {
    dispatch(initiateConfirmation());
  }, [dispatch]);

  useEffect(() => {
    return eventBus.on(EventTypes.ON_PAYMENT_CONFIRMED, handleSubmit);
  }, [handleSubmit]);

  useEffect(() => {
    ProviderWindowService.close(WindowNames.Window);
  }, []);

  const handleCancel = useCallback((): void => {
    dispatch(initiateNewTransaction());
    dispatch(resetPaymentMethod());
  }, [dispatch]);

  return {
    isVisible: isConfirmationFormActivated,
    methodName,
    onSubmit: handleSubmit,
    onCancel: handleCancel,
  };
};
